import { Navigate } from 'react-router-dom'
import { useAuthState } from '../AuthProvider'
import { useRole } from '../../providers/RoleProvider'
import LoadingOverlay from '../../components/LoadingOverlay'

export default function GuardedRoute({ children }: any) {
  const { isAuthenticated, isLoading } = useAuthState()
  const { role, loading: roleLoading } = useRole()

  if (isLoading || roleLoading) {
    return <LoadingOverlay />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }

  if (role === 'secretary') {
    return <Navigate to="/secretary" />
  }

  return children
}
